"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.user_de_de = void 0;
function user_de_de() {
    return {
        "user.salutation": "Anrede",
        "user.salutations.male": "Herr",
        "user.salutations.female": "Frau",
        "user.profile.firstname": "Vorname",
        "user.profile.lastname": "Nachname",
        "user.sso.mergeinstead": "Bitte verknüpfen Sie Ihren Account stattdessen. Melden Sie sich mit Ihrer aktuellen Authentifizierungsmethode an, gehen Sie danach in Ihr Profil und verbinden Sie Ihren neuen Account dort.",
        "user.login.errors.invalidtoken": "Ihre Anmeldedaten sind abgelaufen. Sie werden nun abgemeldet."
    };
}
exports.user_de_de = user_de_de;
